// Announces the Mac Printer Driver to Mac users on landing (ENG-3479).
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox } from 'antd';

import ModalWrapper from './ModalWrapper';
import MacPrintDialog from '../../assets/img/mac_print_dialog.png';
import { openPrinterDriverDownload } from '../../util/printerDriverDownload';
import { dismissMacPrinterDriverAnnouncement } from '../../util/macPrinterDriverAnnouncement';
import { captureAnalytics } from '../../actions/preload';

const imgStyle = {
  display: 'block',
  width: '100%',
  height: 'auto',
  margin: '4px 0 12px',
};

class MacPrinterDriverAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.state = { doNotShowAgain: true };
  }

  // Every way out (Close, the X, the mask, installing) honours the checkbox.
  close = () => {
    const { hideModal } = this.props;
    const { doNotShowAgain } = this.state;
    if (doNotShowAgain) dismissMacPrinterDriverAnnouncement();
    hideModal();
  };

  install = () => {
    captureAnalytics('mac_printer_driver_announcement_download_clicked');
    openPrinterDriverDownload();
    this.close();
  };

  render() {
    const { doNotShowAgain } = this.state;

    return (
      <ModalWrapper
        hideModal={this.close}
        customContentStyle={{ width: '440px' }}
        modalTitle="The Medsender Printer Driver is now available for Mac"
        dismiss="Close"
      >
        <p>
          Install Medsender as a printer on your Mac (macOS 12 or later). Then press &#8984;P in any
          app and choose
          {' '}
          <strong>Medsender File Printer</strong>
          {' '}
          to send the file straight to Medsender.
        </p>
        <img
          src={MacPrintDialog}
          style={imgStyle}
          alt="Mac print dialog with Medsender File Printer selected as the printer"
        />
        <Button type="primary" block style={{ marginBottom: '10px' }} onClick={this.install}>
          Download for Mac
        </Button>
        <Checkbox
          checked={doNotShowAgain}
          onChange={(event) => this.setState({ doNotShowAgain: event.target.checked })}
        >
          Don&apos;t show this to me again
        </Checkbox>
      </ModalWrapper>
    );
  }
}

MacPrinterDriverAnnouncement.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default MacPrinterDriverAnnouncement;
